import { render, staticRenderFns } from "./select-item.vue?vue&type=template&id=09c6d90f&scoped=true"
import script from "./select-item.vue?vue&type=script&lang=js"
export * from "./select-item.vue?vue&type=script&lang=js"
import style0 from "./select-item.vue?vue&type=style&index=0&id=09c6d90f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c6d90f",
  null
  
)

export default component.exports